import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=6b78231e&"
import script from "./PersonCard.vue?vue&type=script&lang=ts&"
export * from "./PersonCard.vue?vue&type=script&lang=ts&"
import style0 from "./PersonCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports